'use client';
import { jsx } from 'react/jsx-runtime';
import '@digdir/designsystemet-web';
import { Slot } from '@radix-ui/react-slot';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Pagination component, used to navigate through a list of items.
 *
 * @example
 * <Pagination>
 *   <Pagination.List>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Forrige side'>Forrige</Pagination.Button>
 *     </Pagination.Item>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Side 1'>1</Pagination.Button>
 *     </Pagination.Item>
 *     <Pagination.Item>
 *       <Pagination.Button aria-label='Side 2'>2</Pagination.Button>
 *     </Pagination.Item>
 *   </Pagination.List>
 * </Pagination>
 */
const Pagination = forwardRef(function Pagination({ asChild, className, ...rest }, ref) {
    const Component = asChild ? Slot : 'ds-pagination';
    return (jsx(Component, { ...(asChild
            ? { className: cl('ds-pagination', className) }
            : { class: cl('ds-pagination', className) }), suppressHydrationWarning // Since ds-pagination will change aria-label and role after hydration
        : true, ref: ref, ...rest }));
});

export { Pagination };
